import { render, staticRenderFns } from "./ViewSegmentation.vue?vue&type=template&id=7d979e1b&scoped=true"
import script from "./ViewSegmentation.vue?vue&type=script&lang=js"
export * from "./ViewSegmentation.vue?vue&type=script&lang=js"
import style0 from "./ViewSegmentation.vue?vue&type=style&index=0&id=7d979e1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d979e1b",
  null
  
)

export default component.exports